export enum CalendarObjectTypes {
    ON_SITE_CONTRACT = 'ON_SITE_CONTRACT',
    DOCUMENT_CONTRACT = 'DOCUMENT_CONTRACT',
    VIDEO_CONTRACT = 'VIDEO_CONTRACT',
    INVOICE = 'INVOICE',
    TASK = 'TASK',
}
